import { useState, useEffect, useContext } from 'react';
import './_FormTable.css';
import { Modal, Button } from 'react-bootstrap';
import { Input, TextArea, Select, TextAreaAdvanced, InputImageUploadSimple, ButtonDropdown } from "../../../Layout/Forms/Form";
import EventFormRequest from "./EventFormRequest";
import { toast } from "react-toastify";

const FormTickets = ({ show, handleModalhide, id, id_events }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            id: id,

        },
        errors: [],
    });

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    useEffect(() => {
        if (show)
            getFormInfo()

    }, [show])


    const getFormInfo = async () => {
        setIsLoading(true);
        let info = await EventFormRequest.getTicketsForm({ id: id, id_events: id_events });
        if (info && info.status) {
            setState({
                ...state,
                form: info.data,
                errors: []
            })
        }
        setIsLoading(false);
    }

    const handleSubmitForm = async () => {
        let errorArray = {};
        let error = false;
        if (state.form.ticketPrice < 4) {
            errorArray = {
                ...errorArray,
                ...{
                    ticketPrice: ["O preço do bilhete tem de ser igual ou superior a 4€"]
                }
            };
            error = true;
        }

        if (!state.form.typeEntry || state.form.typeEntry === "") {
            errorArray = {
                ...errorArray,
                ...{
                    typeEntry: ["O tipo de entrada é obrigatório"]
                }
            };
            error = true;
        }

        if (state.form.typeEntry === "Selecione uma opção") {
            errorArray = {
                ...errorArray,
                ...{
                    typeEntry: ["O tipo de entrada é obrigatório"]
                }
            };
            error = true;
        }

        if (!state.form.name || state.form.name === "") {
            errorArray = {
                ...errorArray,
                ...{
                    name: ["O nome do bilhete é obrigatório"]
                }
            };
            error = true;
        }

        if (!state.form.ticketNumberTotal || state.form.ticketNumberTotal === "") {
            errorArray = {
                ...errorArray,
                ...{
                    ticketNumberTotal: ["O número de bilhetes disponíveis é obrigatório"]
                }
            };
            error = true;
        }

        if (error) {
            toast.error("Verifique os erros apresentados no formulário", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            setState({
                ...state,
                errors: errorArray
            });
            return;
        }

        setIsLoading(true);
        let info = await EventFormRequest.saveTicketsForm({ ...state.form, id_events: id_events });
        if (info) {
            if (info.status) {
                handleModalhide()
            } else {
                setState({
                    ...state,
                    errors: info.errors,
                });
            }
        }
        setIsLoading(false);
    }
    const changesDateStatus = (key) => {
        const dates = state.form.event_dates.map((item, keyList) => {
            return {
                ...item, // Copia todas as propriedades do objeto atual
                isActive: keyList === key ? !item.isActive : item.isActive, // Alterna o atributo isActive somente para o item correspondente
            };
        });

        setState({
            ...state,
            form: {
                ...state.form,
                event_dates: dates, // Atualiza a propriedade event_dates com o novo array
            },
        });
    };


    const ListBtnDatesAcessTicket = () => {
        return state.form && state.form.event_dates ? (
            state.form.event_dates.map((item, key) => {
                const isActive = item.isActive;
                return (
                    <button
                        key={key}
                        onClick={() => changesDateStatus(key)}
                        className={`btn btn-sm d-flex align-items-center gap-2 rounded-pill px-3 py-2 transition-hover ${isActive ? `btn-primary fw-bold shadow-sm` : `btn-outline-secondary text-white-50 border-opacity-25 hover-text-white`} `}
                        style={isActive ? { background: 'var(--primary-gradient)', border: 'none' } : { background: 'transparent' }}
                    >
                        {isActive && <i className="fa-solid fa-check fs-6"></i>}
                        {item.date}
                    </button>
                )
            })
        ) : null
    }

    return (
        <>
            <Modal show={show} onHide={handleModalhide} contentClassName="glass-modal" dialogClassName="reset-width-modal modal-width-50">
                <Modal.Header closeButton>
                    <Modal.Title>Formulário Bilhete</Modal.Title>
                </Modal.Header>

                <Modal.Body className="bg-dark text-white p-4">
                    <div className="animate-fade-in">
                        <h5 className="text-white-50 mb-3 text-uppercase fs-6 ls-1">Informação Geral</h5>
                        <div className="row g-4 mb-4">
                            <div className="col-8">
                                <Input
                                    label="Nome do Bilhete"
                                    name="name"
                                    value={state.form.name}
                                    onChange={(e) => handleChangeInputs(e)}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        handleChangeInputs({
                                            target: {
                                                name: e.target.name,
                                                value: e.clipboardData.getData("Text"),
                                            },
                                        });
                                    }}
                                    type="text"
                                    errors={state.errors}
                                    className="form-control form-input form-control-lg bg-dark-2 border-dark-3 text-white"
                                    placeholder="Ex: Early Bird"
                                />
                            </div>
                            <div className="col-4">
                                <Input
                                    label="Preço (€)"
                                    name="ticketPrice"
                                    value={state.form.ticketPrice}
                                    onChange={(e) => handleChangeInputs(e)}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        handleChangeInputs({
                                            target: {
                                                name: e.target.name,
                                                value: e.clipboardData.getData("Text"),
                                            },
                                        });
                                    }}
                                    type="number"
                                    style={{ textAlign: 'right' }}
                                    errors={state.errors}
                                    className="form-control form-input form-control-lg bg-dark-2 border-dark-3 text-white text-end"
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="col-12">
                                <TextArea
                                    label="Descrição"
                                    name="description"
                                    rows={3}
                                    value={state.form.description}
                                    onChange={(e) => handleChangeInputs(e)}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        handleChangeInputs({
                                            target: {
                                                name: e.target.name,
                                                value: e.clipboardData.getData("Text"),
                                            },
                                        });
                                    }}
                                    type="text"
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                    placeholder="O que está incluído neste bilhete..."
                                />
                            </div>
                        </div>

                        <hr className="border-secondary opacity-25 my-4" />

                        <h5 className="text-white-50 mb-3 text-uppercase fs-6 ls-1">Regras & Limites</h5>
                        <div className="row g-4 mb-4">
                            <div className="col-md-4">
                                <Input
                                    label="Qtd. Disponível"
                                    name="ticketNumberTotal"
                                    value={state.form.ticketNumberTotal}
                                    onChange={(e) => handleChangeInputs(e)}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        handleChangeInputs({
                                            target: {
                                                name: e.target.name,
                                                value: e.clipboardData.getData("Text"),
                                            },
                                        });
                                    }}
                                    type="number"
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                />
                            </div>
                            <div className="col-md-4">
                                <Select
                                    label="Max. por Compra"
                                    name="ticketMaxOrder"
                                    value={state.form.ticketMaxOrder}
                                    onChangeOption={(e) => handleChangeInputs(e)}
                                    options={Array.from({ length: 25 }, (_, index) => ({
                                        label: `${index + 1}`,
                                        value: `${index + 1}`
                                    }))}
                                    style={{ textAlign: "center" }}
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                />
                            </div>
                            <div className="col-md-4">
                                <Select
                                    label="Tipo de Entrada"
                                    name="typeEntry"
                                    value={state.form.typeEntry}
                                    onChangeOption={(e) => handleChangeInputs(e)}
                                    options={[
                                        {
                                            label: "Entrada Única (Valida 1x)",
                                            value: "uniqueEntry"
                                        },
                                        {
                                            label: "Entrada Múltipla",
                                            value: "multipleEntry"
                                        },
                                    ]}
                                    style={{ textAlign: "center" }}
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                />
                            </div>
                        </div>

                        <div className="row g-4 mb-4">
                            <div className="col-12">
                                <label className="form-label text-muted small text-uppercase ls-1 mb-2">Datas de Acesso</label>
                                <div className="bg-dark-2 rounded-3 p-3 border border-secondary border-opacity-10 d-flex flex-wrap gap-2">
                                    <ListBtnDatesAcessTicket />
                                </div>
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-md-6">
                                <Input
                                    label="Início da Venda"
                                    name="ticketDateStart"
                                    value={state.form.ticketDateStart}
                                    onChange={(e) => handleChangeInputs(e)}
                                    type="date"
                                    style={{ textAlign: "center" }}
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                />
                            </div>
                            <div className="col-md-6">
                                <Input
                                    label="Fim da Venda"
                                    name="ticketDateLimit"
                                    value={state.form.ticketDateLimit}
                                    onChange={(e) => handleChangeInputs(e)}
                                    type="date"
                                    style={{ textAlign: "center" }}
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="bg-dark border-top border-secondary border-opacity-10 p-3">
                    <div className="d-flex justify-content-end w-100 gap-2">
                        <Button
                            variant="link"
                            className="text-white text-decoration-none px-4 py-2"
                            onClick={handleModalhide}
                        >
                            Cancelar
                        </Button>
                        <Button
                            className="btn-action-primary px-5 py-2 fw-bold shadow-lg"
                            onClick={() => handleSubmitForm()}
                        >
                            Guardar Alterações
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default FormTickets;